<template>
  <v-app class="bg-surface">
    <AppSystemBar />
    <Toaster
      expand
      rich-colors
      :toast-options="{ class: 'app-notification-wrapper' }"
      :theme="theme.global.current.value.dark ? 'dark' : 'light'"
    />
    <AppProgressNotifications />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </v-app>
</template>

<script lang="ts">
import 'vue-sonner/style.css'
import { defineComponent } from '#imports'
import useUser from '~/composables/useUser'
import { watchImmediate } from '@vueuse/core'
import provideAppSettings from '~/composables/app-settings/provideAppSettings'
import { Toaster } from 'vue-sonner'
import { useTheme } from 'vuetify'
import { AppNotifyTypes, Notify } from '~/lib/notify'
import { useAppStore } from '~/stores/app'
import AppSystemBar from '~/components/Common/AppSystemBar.vue'
import AppProgressNotifications from '~/components/AppProgressNotifications.vue'

export default defineComponent({
  name: 'AppComponent',
  components: { AppSystemBar, Toaster, AppProgressNotifications },
  setup() {
    const appStore = useAppStore()
    const theme = useTheme()
    const { authState } = useUser()
    const { applyTheme } = provideAppSettings()

    watchImmediate(authState.data, (session) => applyTheme(session?.theme))
    return { theme, appStore }
  },
  mounted() {
    // this.testNotify('info')
    // this.$nextTick(() => {
    //   this.testNotify('error')
    //   this.$nextTick(() => {
    //     this.testNotify('warning')
    //     this.$nextTick(() => {
    //       this.testNotify('success')
    //       this.$nextTick(() => {
    //         this.testNotify()
    //       })
    //     })
    //   })
    // })
  },
  methods: {
    testNotify(type?: AppNotifyTypes) {
      Notify(
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloribus, eveniet, reiciendis reprehenderit velit voluptates? Consequuntur doloremque quae ullam. Ab dolor dolorum ex!',
        {
          type,
          action: {
            label: 'test',
            onClick: () => {
              console.log('test')
            },
          },
          lib: {
            duration: Infinity,
          },
        },
      )
    },
  },
})
</script>
